import React, { Component } from "react";
import { createTimeStr } from "utils/common";

class App extends Component {
    //获取视频实例
    videoPlayer = React.createRef();

    state = {
        time: "00:00:00",
        videoProgress: 100
    }

    handleCanPlay = () => {
        this.videoPlayer.current.play();
        typeof this.props.handleCanPlay === "function" && this.props.handleCanPlay();
    }

    handlePlay = () => {}

    handleEnded = () => {
        this.setState({
        	videoProgress: 100
        })
        typeof this.props.stopReplay === "function" && this.props.stopReplay();
    }

    handlePause = () => {
        this.setState({
        	videoProgress: 100
        })
    }

    handleTimeUpdate = () => {
        const videoPlayerElement = this.videoPlayer.current;
        const currentTime = videoPlayerElement.currentTime;
        const duration = videoPlayerElement.duration;
        this.setState({
            time: "00:" + createTimeStr(currentTime),
            videoProgress: (1 - currentTime/duration) * 100
        })
    }

    load = () => {
        //重新加载视频
        this.videoPlayer.current.load();
    }

    pause = () => {
        this.videoPlayer.current.pause();
    }

    render(){
    	const {
    		visible,
    		videoUrl,
	    	question,
	    	questionIndex,
	    	questionTotal,
            stopReplay,
	    	i18n
	    } = this.props;
    	const { time, videoProgress } = this.state;

        return (
        	<div className="video-camera-content" style={{display: visible?"":"none"}}>
	        	<div className="video-camera-contentPhoto">
		            <div id="live-player">
		                <video
		                    src={videoUrl}
		                    onCanPlayThrough={this.handleCanPlay}
		                    onPlay={this.handlePlay}
		                    onPause={this.handlePause}
		                    onEnded={this.handleEnded}
		                    onTimeUpdate={this.handleTimeUpdate}
		                    ref={this.videoPlayer}
		                    id="live-video-player" />
		            </div>
	                <div className="video-progress-wrap">
	                    <div className="video-progress-before"></div>
	                    <div className="video-progress">
	                        <div className="video-progress-inner" style={{width: videoProgress + "%"}}>
	                            <div className="video-progress-dot"></div>
	                        </div>
	                    </div>
	                    <div className="video-progress-after">{time}</div>
	                </div>
	            </div>
                <div className="video-camera-contentTit">
                    <span>{i18n.question.questionText}({(questionIndex < 0 ? 0 : questionIndex) + 1}/{ questionTotal })</span>
                    <p>{i18n.lang == "en_us" ? question.enName : question.cnName}</p>
                </div>
	            <button className="video-tryBtnStop video-tryBtn" onClick={stopReplay}>{i18n.replay.btnText}</button>
        	</div>
        )
    }
}

export default App;